import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pr-details-wrapper',
  templateUrl: './details-wrapper.component.html',
  styleUrls: ['./details-wrapper.component.scss']
})
export class DetailsWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
